import { create } from 'zustand';

export type CloseButtonResult = boolean;
export type CloseButtonInterceptor = () => CloseButtonResult | Promise<CloseButtonResult>;

/**
 * 클로즈 버튼 정보
 */
interface CloseButtonInterceptorInfo {
    interceptor: CloseButtonInterceptor;
}

/**
 *
 */
interface CloseButtonInterceptorStoreState {
    interceptors: CloseButtonInterceptorInfo[];
    register: (interceptor: CloseButtonInterceptorInfo) => void;
    unregister: (interceptor: CloseButtonInterceptor) => void;
    get: () => CloseButtonInterceptor | undefined;
}

export const useCloseButtonInterceptorStore = create<CloseButtonInterceptorStoreState>(
    (set, get) => ({
        interceptors: [],
        register: (info: CloseButtonInterceptorInfo) => {
            set((state) => {
                if (state.interceptors.find((i) => i.interceptor === info.interceptor))
                    return state;
                return {
                    interceptors: [...state.interceptors, info],
                };
            });
        },

        /**
         *
         * @param fn
         */
        unregister: (fn: CloseButtonInterceptor) => {
            set((state) => ({
                interceptors: state.interceptors.filter((h) => h.interceptor !== fn),
            }));
        },

        /**
         *
         * @returns
         */
        get: () => {
            // const filtered = interceptors.filter((i) => i.type === type);
            const { interceptors } = get();
            return interceptors[interceptors.length - 1]?.interceptor;
        },
    }),
);
